@if (editMode) {
  <div></div>
}

@if (!editMode) {
  <div>
    <div>
      <div class="message-text">
        {{ messageText }}
      </div>
    </div>
    <!-- div class="arrow"></div -->
  </div>
}
